module.exports = __webpack_public_path__ + "img/home.b784fbc6.svg";